import { useState, useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { graphService } from '../services/graph';
import { authService } from '../services/auth';

export const useProfilePicture = () => {
  const [profilePicture, setProfilePicture] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthStore();

  useEffect(() => {
    const fetchProfilePicture = async () => {
      if (!user || !user.id) {
        setProfilePicture(null);
        return;
      }

      setIsLoading(true);
      try {
        // Get the current access token
        const token = await authService.getToken();
        if (!token) {
          console.log('No access token available for profile picture fetch');
          return;
        }

        // Fetch profile picture from Microsoft Graph
        const pictureUrl = await graphService.getUserPhoto(token, user.id);
        setProfilePicture(pictureUrl);
        
      } catch (error) {
        console.error('Error in useProfilePicture hook:', error);
        setProfilePicture(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfilePicture();

    // Cleanup function to revoke blob URLs when component unmounts
    return () => {
      if (profilePicture && profilePicture.startsWith('blob:')) {
        URL.revokeObjectURL(profilePicture);
      }
    };
  }, [user?.id]); // Only re-fetch if user ID changes

  return { profilePicture, isLoading };
};